import firebase from '../../../firebase'

var db = firebase.firestore();

const getConversationContactData = (conversation, next) => {
  var {other} = conversation

  return db.collection("userProfiles").where('userId', '==', other)

    .get()

    .then(({docs}) => {
      var contactProfile = {}

      if (docs.length > 0) {
        contactProfile = docs[0]
      }

      return next({
        type: "conversationContactResponse",
        conversationContactResponse: {
          ...contactProfile.data(),
          conversationUid: conversation.id
        }
      })

    })

    .catch(contactProfileError => {

      return next({
        type: "conversationContactError",
        contactProfileError
      })

    })


}
export const getConversationsContactInfo = (conversations, next) => {

  conversations
    .filter(({other}) => other && other.length)
    .forEach(conversation => {
      getConversationContactData(conversation, next)

    })

}


// WEBPACK FOOTER //
// ./src/Components/Conversations/middleware/contact-info.js